import { render, staticRenderFns } from "./EventSingle.vue?vue&type=template&id=2d5f46f8"
import script from "./EventSingle.vue?vue&type=script&lang=js"
export * from "./EventSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports